import { forwardRef } from 'react';

import { ApplySelectOverlayButton } from 'components/Inputs/SelectOverlay';
import Select from 'components/Inputs/Select';
import CheckboxInlineField from 'components/Fields/InlineTableFieldInput/Checkbox';

import { withCellWrapper } from './helpers';

const _CheckboxCell = forwardRef(
  (
    {
      field,
      entityId,
      entityAccess,
      onSubmit,
      value,
      objectId,
      serviceToUse,
      fetchUrl,
      handleUpdateFieldOption,
      handleUpdateTableRecords,
      menuLeftButton,
      menuRightButton,
      placeholder,
      info,
      showDisplayNameTooltip,
      column,
      readOnly,
      onAutoFocus,
      ...others
    },
    ref
  ) => {
    return (
      <CheckboxInlineField
        ref={ref}
        {...others}
        value={value}
        onSubmit={onSubmit}
        readOnly={readOnly}
        onAutoFocus={onAutoFocus}
        field={field}
        entityId={entityId}
      >
        <Select menuRightButton={<ApplySelectOverlayButton />} />
      </CheckboxInlineField>
    );
  }
);

export const CheckboxCell = withCellWrapper(_CheckboxCell);
